import loadable from '@loadable/component';

export default {
  exact: false,
  path: '/__tests__/:file/:export?',
  // loadable generates bundle names based on import so we need to not call them "index"
  component: loadable(async () => import('./tests.view')),
};
